import React, { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../common_nextgen/axios/AxiosHelper";
import FunctionKeys from "../../common_nextgen/common_components/FunctionKeys/FunctionKeys";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";
import Form from "../../common_nextgen/common_components/form/Form";
import { useToast } from "../../common_nextgen/hooks/ToastContext";
import {
  PRICE_SCHEDULE_MODES,
  ROUTE_PATHS,
} from "../../common_nextgen/utils/Constants";
import {
  isAddMode,
  isEditMode,
  isReadOnlyMode,
} from "../../common_nextgen/utils/UtilFunctions";
import { formFields } from "./DrugStatusScheduleFormConfig";

const screenInfo = {
  ADD: ["Add Drug Status In Benefit Max Drug Status Sched", "RCBDD002"],
  CHANGE: ["Drug Status In Benefit Max Drug Status Sched Detail", "RCBDD003"],
};

const DrugStatusForm = ({ mode }) => {
  const {
    BENEFIT_MAX_DRUG_STATUS_SCHEDULE,
    EDIT_BENEFIT_MAX_DRUG_STATUS_SCHEDULE,
  } = ROUTE_PATHS;
  const location = useLocation();
  const navigateToPage = useCustomNavigate();
  const { state: stateVal } = location;
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  console.log("current state in form", currentState, previousState);
  const {
    selectedSchedules = [],
    selectedDescriptions = [],
    bddDrugStatus = [],
    bddPreferredStatus = [],
    previousScreen = ROUTE_PATHS.DRUG_STATUS_SCHEDULE,
    currentIndex: initialIndex = 0,
    initialParamsData = {
      bmdScheduleCode: selectedSchedules[initialIndex]?.bmdScheduleCode,
      bmdDescription: selectedDescriptions[initialIndex]?.bmdDescription,
      bddDrugStatus: bddDrugStatus[initialIndex]?.bddDrugStatus,
      bddPreferredStatus: bddPreferredStatus[initialIndex]?.bddPreferredStatus,
    },
  } = currentState;
  console.log("initialParamsData", initialParamsData, previousState);
  const [paramsData, setParamsData] = useState(initialParamsData);
  const [selectedOption, setSelectedOption] = useState("no");
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [currentMode, setCurrentMode] = useState(mode);
  const [initialFormData, setInitialFormData] = useState({
    bmdScheduleCode: selectedSchedules[initialIndex]?.bmdScheduleCode,
    bmdDescription: selectedDescriptions[initialIndex]?.bmdDescription,
    bddDrugStatus: bddDrugStatus[initialIndex]?.bddDrugStatus,
    bddPreferredStatus: bddPreferredStatus[initialIndex]?.bddPreferredStatus,
  });
  const { axios_helper_no_header } = useAxios();

  const [dataForSubmission, setDataForSubmission] = useState({});
  const [constraintErrors, setConstraintErrors] = useState([]);
  const toast = useToast();

  const handleBack = () => {
    if (currentIndex < bddDrugStatus.length - 1) {
      setCurrentIndex(currentIndex + 1);
      setCurrentMode(mode);
    } else {
      navigateToPage(previousScreen, previousState);
    }
  };

  const getPageTitle = () => {
    const [screenTitle, screenNumber] = isAddMode(mode)
      ? screenInfo.ADD
      : screenInfo.CHANGE;
    return (
      <>
        <span className="title">{screenTitle}</span>
        <span>{"-"}</span>
        <span className="screen-number">{screenNumber}</span>
      </>
    );
  };

  const submitFormData = (data) => {
    setDataForSubmission(data);
  };

  const submitForm = async (dataForSubmission) => {
    let url = "";
    let verb = "";
    let screenNumber = "";

    if (isAddMode(currentMode)) {
      url = "api/bddBenMaxDrugStsDet";
      verb = "POST";
      screenNumber = screenInfo.ADD[1];
    } else {
      url = "api/bddBenMaxDrugStsDet";
      verb = "PUT";
      screenNumber = screenInfo.CHANGE[1];

      if (
        JSON.stringify(dataForSubmission) === JSON.stringify(initialFormData)
      ) {
        toast.current.show({
          severity: "info",
          summary: "",
          detail: "No Change of Information",
          life: 3000,
        });
        return;
      }
    }

    const data = { ...dataForSubmission, screenNumber };

    try {
      const { responseStatus, responseData } = await axios_helper_no_header(
        verb,
        url,
        data,
        null
      );
      toast.current.show({
        severity: "success",
        summary: "",
        detail: responseStatus.message,
        life: 3000,
      });
      setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
      setInitialFormData({
        ...responseData,
        bmdDescription: selectedDescriptions[currentIndex].bmdDescription,
      });
    } catch (error) {
      const {
        responseStatus: { displayErrorFields = null, message },
      } = error.data;
      if (displayErrorFields === null) {
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      } else {
        setConstraintErrors(displayErrorFields);
      }
    }
  };

  const [keyFunc, keyName] = useMemo(() => {
    const keyFunc = {};
    const keyName = {};

    if (isAddMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
    } else if (isEditMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.READ_ONLY);
      keyName.chmod = "View";
    } else if (isReadOnlyMode(currentMode)) {
      keyFunc.F12 = handleBack;
      keyName.F12 = "Back";
      keyFunc.chmod = () => setCurrentMode(PRICE_SCHEDULE_MODES.EDIT);
      keyName.chmod = "Edit";
    }

    return [keyFunc, keyName];
  }, [currentMode, currentIndex]);

  useEffect(() => {
    const fetchInitialData = async () => {
      const paramsData = {
        bmdScheduleCode: selectedSchedules[initialIndex]?.bmdScheduleCode,
        bmdDescription: selectedDescriptions[initialIndex]?.bmdDescription,
        bddDrugStatus: bddDrugStatus[currentIndex]?.bddDrugStatus,
        bddPreferredStatus:
          bddPreferredStatus[currentIndex]?.bddPreferredStatus,
      };
      const url = isAddMode(currentMode)
        ? `api/bddBenMaxDrugStsDet/initialFormData/${screenInfo.ADD[1]}`
        : `api/bddBenMaxDrugStsDet/${encodeURIComponent(
            selectedSchedules[initialIndex].bmdScheduleCode
          )}/${encodeURIComponent(bddDrugStatus[currentIndex].bddDrugStatus)}`;
      const { responseData } = await axios_helper_no_header(
        "GET",
        url,
        null,
        paramsData
      );
      setInitialFormData({
        ...responseData,
        bmdDescription: selectedDescriptions[initialIndex].bmdDescription,
      });
    };

    fetchInitialData();
  }, [mode, currentIndex]);

  return (
    <div className="grid container">
      <div className="col col-12">
        <FunctionKeys keyFunc={keyFunc} keyName={keyName} />
      </div>
      <div className="col col-12">
        <h1>{getPageTitle()}</h1>
      </div>
      <div className="col col-12">
        <Form
          formData={initialFormData}
          formFields={formFields}
          mode={currentMode}
          submitFormData={submitForm}
          constraintErrors={constraintErrors}
        />
      </div>
    </div>
  );
};

export default DrugStatusForm;